import {Avatar} from 'antd';
import {AvatarProps} from 'antd/es/avatar';
import React from 'react';

type Props = {
  email?: string;
};

// This function returns the favicon URL for the given email
export const getFaviconUrl = (email?: string) => {
  if (!email) return undefined;

  // Split the email into parts
  const parts = email.split('@');
  if (parts.length !== 2 || !parts[1]) return undefined;

  // Get the domain from the email
  const domain = `https://${parts[1]}`;

  // Return the favicon URL
  if (domain) return `https://d1l5mg5ladb8cd.cloudfront.net/icon?url=${domain}&size=16..32..64`;

  return undefined;
};

export const EmailFavicon: React.FC<Props & AvatarProps> = ({email, ...props}) => {
  const iconUrl = getFaviconUrl(email);
  return <Avatar {...props} src={iconUrl} />;
};
